/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { licensesDeactivate } from "../../funcs/licensesDeactivate.js";
import * as components from "../../models/components/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: components.DeactivateLicenseRequestEntity$inboundSchema,
};

export const tool$licensesDeactivate: ToolDefinition<typeof args> = {
  name: "licenses-deactivate",
  description: `Deactivate a license key instance.

Remove a device activation from a license key. Free up activation slots for new devices.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await licensesDeactivate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
